module.exports = "<h3 style=\"margin-bottom: 24px\">\n    Engineering and Coding\n</h3>\n\n<div class=\"flexCol\">\n    <img src=\"../../assets/Coding.jpg\" class=\"rounded\" alt=\"StockCoding\" />\n</div>\n\n<h5>Articles:</h5>\n<div style=\"margin-bottom: 24px\">\n    <ul>\n        <li>\n            <a routerLink=\"/advent-of-code\"><h5>Advent of Code</h5></a>\n        </li>\n    </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/masonpimentel/Repos/mason-blog/src/app/home-engineering-coding/home-engineering-coding.component.html
// module id = ../../../../../src/app/home-engineering-coding/home-engineering-coding.component.html
// module chunks = main